import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminOperationLogList } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Admin/AdminOperationLog",
    getList: "getList"
});

export const getListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async (_, { rejectWithValue }) => {
        const response = await getAdminOperationLogList();

        if (response.error === undefined) {
            return { logList: response.logList };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);
